declare global {
    interface Window {
      env?: Record<string, string>
    }
  }
  function getEnv(key: string): string {
    const value = window.env?.[key]
    // Отфильтровываем Docker-плейсхолдеры вида __KEY__
    // (на случай если middleware не сработал и браузер получил оригинальный env.js)
    if (value && !(value.startsWith('__') && value.endsWith('__'))) {
      return value
    }
    return ''
  }
  export const appConfig = {
    keycloak: {
      realm: getEnv('REACT_APP_KEYCLOAK_REALM'),
      url: getEnv('REACT_APP_KEYCLOAK_AUTH_SERVER_URL'),
      clientId: getEnv('REACT_APP_KEYCLOAK_CLIENT_ID'),
    },
    mapStationCode: getEnv('REACT_APP_MAP_STATION_CODE'),
    roleSource: getEnv('ROLE_SOURCE'),
    roleSourceClient: getEnv('ROLE_SOURCE_CLIENT'),
  }
  export { getEnv }